@if (isFeaturedId || hotel.marketing_action) {
  <div class="header-featured">
    <p class="featured-text">
      @if (hotel.marketing_action) {
        {{ hotel.marketing_action }}
      } @else {
        ¡Encontramos el alojamiento que buscabas!
      }
    </p>
  </div>
}
<mb-card class="hotel" elevation="hover" (click)="isMobile || hiddenPopover()">
  <div class="hotel__content mb--grid-container-full" [ngClass]="{ 'mb-grid-row': !isMobile }">
    <div class="image mb-grid-col-4-dt mb-grid-col-12">
      <mb-carousel backgroundImage [brand]="brand" class="carousel" [infinity]="false" [showNumbers]="false" [showDots]="isMobile"
        [images]="imageUrls"></mb-carousel>
      @if (hotel.offer && hotel.hotel_chain !== 'DISNEY') {
        <am-outstanding-promo [offer]="hotel.offer"></am-outstanding-promo>
      }
      <am-trips-add-product productType="HOTEL" [product]="tripFavoriteData"
        [currencyCode]="currencyCodeToTripFavorite"></am-trips-add-product>
      @if (hotel?.rate?.meal_plan?.code && hotel.rate.meal_plan.code !== 'ROOM_ONLY') {
        <mb-advice class="image__advice" color="light">
          <mb-icon-text>
            @if (hotel.rate.meal_plan.code === 'FULL_BOARD') {
              <mb-icon icon="full-board"></mb-icon>
            }
            @if (hotel.rate.meal_plan.code === 'ALL_INCLUSIVE') {
              <mb-icon icon="all-inclusive"></mb-icon>
            }
            @if (
                hotel.rate.meal_plan.code === 'CONTINENTAL_BREAKFAST' ||
                hotel.rate.meal_plan.code === 'FULL_BREAKFAST' ||
                hotel.rate.meal_plan.code === 'BREAKFAST_BUFFET' ||
                hotel.rate.meal_plan.code === 'CONTINENTAL_BREAKFAST_FOR_2' ||
                hotel.rate.meal_plan.code === 'BREAKFAST_FOR_2' ||
                hotel.rate.meal_plan.code === 'BED_AND_BREAKFAST' ||
                hotel.rate.meal_plan.code === 'BREAKFAST'
              ) {
              <mb-icon icon="breakfast"></mb-icon>
            }
            @if (
                hotel.rate.meal_plan.code === 'HALF_BOARD_MORE_DRINKS' ||
                hotel.rate.meal_plan.code === 'HALF_BOARD' ||
                hotel.rate.meal_plan.code === 'FREE_DINNER' ||
                hotel.rate.meal_plan.code === 'FREE_LUNCH'
              ) {
              <mb-icon icon="mealplan"></mb-icon>
            }
            @if (
                hotel.rate.meal_plan.code === 'DISNEY_DELUXE' ||
                hotel.rate.meal_plan.code === 'DISNEY_DINING' ||
                hotel.rate.meal_plan.code === 'DISNEY_QUICK_DINING'
              ) {
              <mb-icon icon="mealplan"></mb-icon>
            }
            <span>{{ hotel.rate.meal_plan.description }}</span>
          </mb-icon-text>
        </mb-advice>
      }
      <div class="image__experts-share-container" (click)="trackExpertsShareEvent()">
        @if (promotion && promotion.type === 'campaign') {
          <span class="promotion-campaign">{{ promotion.description }}</span>
        }
        <am-experts-share [productDetail]="getUrl(hotel)" [size]="'sm'" [locale]="locale"></am-experts-share>
      </div>
      @if (hotel.hotel_chain === 'DISNEY') {
        <div class="disney">
          <p class="disney-text">
            <mb-icon class="icon icon-disney" icon="disney"></mb-icon>
            <span class="text" i18n="@@hotel_disney">Hotel Disney</span>
          </p>
        </div>
      }
    </div>
    <ng-template #recommendedTooltip>
      <span [ngStyle]="{ 'display': 'block', 'font-size': '14px', 'font-weight': 'bold' }"
        i18n="@@recommended__for-you">¡Te lo recomendamos!</span>
      <br />
      <span i18n="@@recommended__quality-price">
        Este alojamiento forma parte de nuestro programa de Alojamientos Recomendados por una buena
        relación calidad-precio y los comentarios de nuestros pasajeros.
      </span>
    </ng-template>
    <div class="details mb-grid-col-5-dt mb-grid-col-12">
      <div class="--flex-grow-one">
        @if (hotel.recommended) {
          <div [mb-tooltip]="recommendedTooltip" mbTooltipColor="light" mbTooltipPosition="below"
            class="details__recommended">
            <mb-icon icon="crown"></mb-icon>
            <span>Alojamiento recomendado</span>
          </div>
        }

        <span class="details__title" (click)="detailRedirect()">
          <span class="details__title__name" title="{{ hotel.name }}">
            {{ hotel.name }}
          </span>
        </span>
        @if (hotel.distanceToPoi && nearBy?.description) {
          <span class="details__distance-to-poi" i18n="@@hotel__distance-to-poi">
            A {{ hotel.distanceToPoi }} metros de {{ nearBy.description }}
          </span>
        }
        <div class="details__address" title="{{ hotel.address }}">
          <ng-template #mapDialog let-dialogRef let-dialogData="data">
            <mb-dialog class="mb-dialog-custom" [fullScreenMobile]="true">
              <mb-dialog-header [showCloseBtn]="true" (closeDialog)="dialogRef.close()">
                <h3 class="map-dialog__title">Ubicación del alojamiento</h3>
              </mb-dialog-header>
              <mb-dialog-body>
                <div class="mb-dialog-body-custom">
                  <div class="hotel__map-container">
                    <google-map height="100%" width="100%" [center]="center" [zoom]="zoom" [options]="mapOptions">
                      <map-marker [position]="center" [title]="hotel.name" [id]="hotel.id" [options]="markerOptions"></map-marker>
                    </google-map>
                  </div>
                </div>
              </mb-dialog-body>
            </mb-dialog>
          </ng-template>
          @if (hotel.isHomestays) {
            <div class="temporary-rent-text">
              <span>Alquiler temporario</span>
              @if (hotel?.beds > 0 && hotel?.max_room_occupancy > 0) {
                <span class="separator"></span>
                <mb-icon-text>
                  <mb-icon icon="adult"></mb-icon>
                  <span>{{ hotel.max_room_occupancy }}</span>
                </mb-icon-text>
                <mb-icon-text>
                  <mb-icon icon="hotels"></mb-icon>
                  <span>{{ hotel.beds }} camas</span>
                </mb-icon-text>
              }
            </div>
          } @else {
            <div class="details__subtitle">
              <mb-stars-rating class="details__subtitle__stars" [rating]="hotel.stars"></mb-stars-rating>
              @if (hotel?.amenities.length > 0) {
                @for (iconName of hotel.amenities | slice: 0:4; track iconName) {
                  <ng-template #tooltip>
                    <div class="amenityText">{{ iconName.description }}</div>
                  </ng-template>
                  <mb-icon class="details__subtitle__amenity" [mb-tooltip]="tooltip" mbTooltipColor="dark"
                    mbTooltipPosition="below" [icon]="iconName.icon"></mb-icon>
                }
              }
            </div>
          }
        </div>
        <div class="mapAndMiami">
          <mb-icon-text class="details__address__map" (click)="openDialog()">
            <mb-icon icon="pointer"></mb-icon>
            <span>Ver en mapa</span>
          </mb-icon-text>
          @if (showAddressBadge) {
            <mb-badge size="small">Miami Beach</mb-badge>
          }
        </div>
        @if (hotel.rate.refundable) {
          <mb-badge class="details__refundable" size="small" color="success"
            i18n="@@cancelation__free">¡Cancelación gratis!
          </mb-badge>
        }
        <div>
          @switch (paymentMethodText) {
            @case ('PREPAID') {
              <mb-badge class="details__refundable" size="small">
                @if (currencyCodeToTripFavorite === 'USD') {
                  Pago en dólares
                } @else {
                  {{
                  hotel.country === '1123215'
                  ? 'Pagar ahora en cuotas'
                  : 'Pagá ahora en 1 cuota en pesos'
                  }}
                }
              </mb-badge>
            }
            @case ('PAY_AT_DESTINATION') {
              <mb-badge class="details__refundable" size="small"
                i18n="@@payment__in-hotel">Pagar al alojamiento
              </mb-badge>
            }
            @default {
              <mb-badge class="details__refundable" size="small">{{
                hotel.country == '1123215'
                ? 'Pagar ahora en cuotas'
                : 'Pagá ahora en 1 cuota en pesos'
                }}
                o al alojamiento
              </mb-badge>
            }
          }
        </div>
        @if (!hotel.rate.supplement && hotel.hotel_chain === 'DISNEY') {
          <div class="details__subtitle__disney-info">
            <a (click)="detailRedirect()" class="link">
              <mb-icon-text>
                <mb-icon icon="magic"></mb-icon>
                <span i18n="@@hotel__discounts__meal-and-tickets">Con este hotel aprovechá descuentos en <strong>planes de
                    comida</strong> y
                  <strong>tickets a parques</strong> temáticos
                </span>
              </mb-icon-text>
            </a>
          </div>
        }
      </div>
      @if (ratingSummary) {
        <mb-reviews-rating rating="{{ hotel.rating > 4 ? hotel.rating : '' }}">
          <mb-reviews-evaluation>{{ ratingSummary?.ratingLabel }}
          </mb-reviews-evaluation>
          @if (ratingSummary?.review_qty) {
            <mb-reviews-detail>
              {{ ratingSummary?.review_qty }} opiniones
            </mb-reviews-detail>
          }
        </mb-reviews-rating>
      }
    </div>
    <div class="prices mb-grid-col-3-dt mb-grid-col-12">
      <ng-template #promotionPopover>
        <span class="prices__promotion-rate-tag__label">{{ promotion.description }}</span>
      </ng-template>
      <am-hotel-price (deferLoad)="startPromotion()" [mb-popover]="promotionPopover" [mbPopoverDismissible]="true"
        [mbPopoverShow]="false" mbPopoverColor="success" [mbPopoverPosition]="isMobile ? 'above' : 'left'"
        [isLanding]="isLanding" [query]="query" [hotel]="hotel" [currencyToCompensation]="currencyCode"
        [context]="context" (detailRedirect)="detailRedirect()" [paymentMethodText]="paymentMethodText"
        [mbAdvicePosition]="isMobile ? 'right' : 'left'" [isMobile]="isMobile" #hotelPrice>
      </am-hotel-price>
    </div>
  </div>
</mb-card>
@if (isFeaturedId && hasRelated) {
  <div class="hotel__footer-featured">
    <p class="hotel__footer-featured__text" i18n="@@hotel__footer-featured">
      También encontramos estos alojamientos que pueden interesarte
    </p>
  </div>
}
@if (!!recommendedHotels.length && recommendedHotelsReference === hotel.id) {
  <am-recommended-hotels [hotels]="recommendedHotels" [reference]="hotel" [query]="query" [isLanding]="isLanding"
    [isMobile]="isMobile">
  </am-recommended-hotels>
}